import type { FC } from 'react'
import { Switch as MuiSwitch, type SwitchProps as MuiSwitchProps } from '@mui/material'

/**
 * The MUI Switch with `color` and `size` taken out.
 *
 * The theme already sets these, so passing them does nothing.
 * hiding them from the type just stops us doing it by accident.
 */
type SwitchProps = Omit<MuiSwitchProps, 'color' | 'size'>

export const Switch: FC<SwitchProps> = MuiSwitch
